module.exports = __webpack_public_path__ + "Icon-image-view.png";